import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Wrapper from "../assets/wrappers/MeetingAuthPage";
import { login } from "../features/authSlice";
import { useDispatch } from "react-redux";
const FiLock = require("react-icons/fi").FiLock;

const MeetingAuthentication: React.FC = () => {
  const baseUrl = process.env.REACT_APP_BASE_URL;
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [isChecked, setIsChecked] = useState(false);
  const [error, setError] = useState(false);
  const [authFailed, setAuthFailed] = useState(false);

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const token = params.get("token");

    if (!token) {
      setTimeout(() => {
        setAuthFailed(true);
        setLoading(false);
      }, 3000);
      return;
    }

    const validateToken = async () => {
      const startTime = Date.now();

      try {
        const response = await fetch(`${baseUrl}api/nirnay/login`, {
          method: "POST",
          headers: {
            accept: "application/json",
            "Content-Type": "application/json",
            lang: "en-IN",
          },
          body: JSON.stringify({ token }),
        });

        const data = await response.json();

        const elapsed = Date.now() - startTime;
        const remaining = 3000 - elapsed;

        setTimeout(() => {

          if (data?.payload?.user_details?.msg_code !== 200) {
            setAuthFailed(true);
            localStorage.removeItem("loginDetails");
            localStorage.removeItem("meetingDetailsNirnany");
            localStorage.removeItem("portal");

          } else {

            setAuthFailed(false);
            setShowModal(true);

            localStorage.setItem(
              "loginDetails",
              JSON.stringify(data?.payload?.user_details || "")
            );
            localStorage.setItem("portal", "N");
            localStorage.setItem(
              "meetingDetailsNirnany",
              JSON.stringify(data?.payload?.meeting_details || "")
            );

            const tokenObj = {
              access_token: data.access_token,
              token_type: data.token_type,
            };

            dispatch(
              login({
                portal: "N",
                meetingDetailsNirnany: data?.payload?.meeting_details || null,
                token: tokenObj,
              })
            );

            const newUrl =
              window.location.origin + window.location.pathname;
            window.history.replaceState(null, "", newUrl);
          }
          setLoading(false);
        }, remaining > 0 ? remaining : 0);

      } catch (error) {
        console.error("Decode API Error", error);
        setTimeout(() => {
          setAuthFailed(true);
          setLoading(false);
        }, 3000);
      }
    };



    validateToken();
  }, [location.search]);

  const handleAgree = () => {
    if (!isChecked) {
      setError(true);
      return;
    }
    localStorage.setItem("uploadConsent", "true");
    navigate("/upload");
  };

  return (
    <Wrapper>
      <div className="auth-card">
        <div className="iconBox">
          <FiLock size={36} color="#ec0986ff" />
        </div>

        {loading && (
          <>
            <h2 className="title d-flex justify-content-center" style={{ color: '#ec0986ff' }}>
              Authenticating
              <div className="dots-loader mx-2">
                <span></span><span></span><span></span>
              </div>
            </h2>
            <p className="subtitle">Verifying your meeting details...</p>
          </>
        )}

        {!loading && authFailed && (
          <div className="text-center mt-4">
            <h2 className="title text-danger">Invalid or Expired Link </h2>
            <p className="subtitle">
              Your authentication link is not valid or has expired.
            </p>

            <button
              className="btn btn-danger mt-3"
              onClick={() => navigate(-1)}
            >
              Go Back
            </button>
          </div>
        )}

        {!loading && !authFailed && (
          <>
            <h2 className="title">Authentication Successful ✔</h2>
            <p className="subtitle">Proceed with confirmation</p>
          </>
        )}
      </div>

      {showModal && !loading && !authFailed && (
        <div
          className="modal fade show d-block"
          style={{
            background: "linear-gradient(135deg, rgb(97 58 245 / 12%), rgb(214 51 132 / 13%))"
          }}

          tabIndex={-1}
        >
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content p-3">
              <h5 className="modal-title mb-3">Confirmation</h5>
              <p>
                I confirm that the minutes generated through the Video/Audio
                uploaded shall be available in the public domain and stored by
                the Ministry of Panchayati Raj as per its Data Archival policy.
              </p>

              <div className="form-check my-3">
                <input
                  type="checkbox"
                  className="form-check-input"
                  id="agreeCheckbox"
                  checked={isChecked}
                  onChange={(e) => {
                    setIsChecked(e.target.checked);
                    setError(false);
                  }}
                />
                <label className="form-check-label" htmlFor="agreeCheckbox">
                  I Agree
                </label>

                {error && <p className="text-danger modal-error-text">Please check the box to agree.</p>}
              </div>

              <div className="d-flex justify-content-end gap-2">
                {/* <button
                  className="btn btn-danger"
                  onClick={() => navigate(-1)}
                >
                  Go Back
                </button> */}
                <button className="btn btn-primary" onClick={handleAgree}>
                  Agree & Continue 
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </Wrapper>
  );
};

export default MeetingAuthentication;
